// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__r0-tV","leftHalf":"styles_leftHalf__110iA","rightHalf":"styles_rightHalf__1wfz6"};